module.exports = __webpack_public_path__ + "static/media/stage2@2x.a972fdd5.webp";